import { Grid, Typography } from '@mui/material';
import React, { FC, PropsWithChildren, ReactElement } from 'react';

interface Props {
  label: string;
}

export const ErrorPage: FC<PropsWithChildren<Props>> = (props: PropsWithChildren<Props>): ReactElement => {
  const { label, children } = props;

  return (
    <Grid container={true} direction={'column'} wrap={'nowrap'}>
      <Grid item={true} mb={4}>
        <Typography variant={'h2'}>{label}</Typography>
      </Grid>
      <Grid item={true}>{children}</Grid>
    </Grid>
  );
};
